import gql from 'graphql-tag';
import { KinderConnectCaptureChildSettingFields } from './kinder-connect-capture-child-setting.fragment';
export const KinderConnectCaptureChildren = gql `
    query KinderConnectCaptureChildren($siteId: SiteId!) {
        attendance {
            childCheckins {
                kinderConnectCaptureChildren(siteId: $siteId) {
                    ...KinderConnectCaptureChildSettingFields
                }
            }
        }
    }
    ${KinderConnectCaptureChildSettingFields}
`;
